<template>
    <div class="footer">
        <!-- <div class="bg"></div> -->
        <img src="@/assets/logo.png" class="logo" alt="">
        <div class="line"></div>
        <div class="text">
            <p class="p1">区块链浏览器</p>
            <p class="p2">Blockchain Browser</p>
        </div>
    </div>
</template>
<script setup>

</script>
<style scoped>

.footer{
    display: flex;
    align-items: center;
    padding-left: 30px;
    height: 96rem;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, .4);
    overflow: hidden;
    position: relative;
    backdrop-filter: saturate(180%) blur(10px);
}
/* .bg{
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: -1;
    filter: blur(4px);
    background: url('~@/assets/home/bg.png') center bottom no-repeat;
    background-size: 100% auto;
    transform: scale(1.1);
} */
.logo{
    width: 152rem;
}
.line{
    width: 1px;
    height: 64rem;
    background: rgba(255, 255, 255, 0.2);
    margin: 0 27rem 0 23rem;
}
.text .p1{
    font-size: 17.6rem;
    line-height: 24rem;
    color: #fff;
}
.text .p2{
    font-size: 12.8rem;
    line-height: 18rem;
    margin-top: 2rem;
    color: #6A6C78;
}
</style>